/**
 * 获取两点之间的点集合
 * @param {*} from 
 * @param {*} to 
 */
export default (from, to) => {
  var points = [[from.x, from.y], [to.x, to.y]];
  var ex = points[1][0];
  var ey = points[1][1];
  points[3] = [ex, ey];
  points[1] = getOffsetPoint(points[0], points[3]);
  points[2] = getOffsetPoint(points[3], points[0]);
  points = smoothSpline(points, false);
  //修正最后一点在插值产生的偏移
  points[points.length - 1] = [ex, ey];
  return points;
};
/**
 * 
 * @param {*} start 
 * @param {*} end 
 */
let getOffsetPoint = function (start, end) {
  var distance = getDistance(start, end) / 3; //除以3？
  var angle, dX, dY;
  var mp = [start[0], start[1]];
  var deltaAngle = -0.2; //偏移0.2弧度
  if (start[0] != end[0] && start[1] != end[1]) {
    //斜率存在
    var k = (end[1] - start[1]) / (end[0] - start[0]);
    angle = Math.atan(k);
  } else if (start[0] == end[0]) {
    //垂直线
    angle = (start[1] <= end[1] ? 1 : -1) * Math.PI / 2;
  } else {
    //水平线
    angle = 0;
  }
  if (start[0] <= end[0]) {
    angle -= deltaAngle;
    dX = Math.round(Math.cos(angle) * distance);
    dY = Math.round(Math.sin(angle) * distance);
    mp[0] += dX;
    mp[1] += dY;
  } else {
    angle += deltaAngle;
    dX = Math.round(Math.cos(angle) * distance);
    dY = Math.round(Math.sin(angle) * distance);
    mp[0] -= dX;
    mp[1] -= dY;
  }
  return mp;
};

let smoothSpline = function (points, isLoop) {
  var len = points.length;
  var ret = [];
  var distance = 0;
  for (var i = 1; i < len; i++) {
    distance += getDistance(points[i - 1], points[i]);
  }
  var segs = distance / 2;
  segs = segs < len ? len : segs;
  for (var i = 0; i < segs; i++) {
    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
    var idx = Math.floor(pos);
    var w = pos - idx;
    var p0;
    var p1 = points[idx % len];
    var p2;
    var p3;
    if (!isLoop) {
      p0 = points[idx === 0 ? idx : idx - 1];
      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
    } else {
      p0 = points[(idx - 1 + len) % len];
      p2 = points[(idx + 1) % len];
      p3 = points[(idx + 2) % len];
    }
    var w2 = w * w;
    var w3 = w * w2;

    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
  }
  return ret;
};

let interpolate = function (p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
};

let getDistance = function (p1, p2) {
  return Math.sqrt((p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]));
};


// WEBPACK FOOTER //
// ./src/utils/SmoothSpline.js